module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAAAXNSR0IArs4c6QAAANBJREFUKBWV0T0OwiAUB/ACjXH2Bk06uDo7ljC5OXsNT+I13NwEBhNnd5d6Ag/QNsX3V2sUC1USQoD3fo+PJBloUsoZ+kBYwmIBANq21YjhnEut9SkUH4Q6xDk3QTJj7BrDeqF3hIAKEIGjGPYF+QglL5/QNoZ9QH2IMWYHqCiKBUFB7AXFEEBoMewO/YI8qDDGlFLTpmmO+B08LN6ku06X7I/+ydI0nfO6rlf/IEBRCAVRGLkwRJ7nF5qMaXFtrd371UPzsizPWZYdaL8SQmxuRyi6Kvi9tuUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/path.png
// module id = R3cG
// module chunks = 0